import React, { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CheckIcon from '@mui/icons-material/Check';
import { Link, useNavigate } from "react-router-dom";
import Drawer from '@mui/material/Drawer';
import Radio from '@mui/material/Radio';
import CryptoJS from 'crypto-js';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import { baseURL, checkoutValidate, getCustomerBillingAddress, offerApply, offerRemove, submitCustomerCart } from "../../networkCalls/index";
import { useStateValue, actionTypes } from "../../store";
import { getCustomerAddressList } from '../../networkCalls';
import { Box, Button, Chip } from '@mui/material';
import CheckoutProductCell from './CheckoutProductCell';
import CheckoutTotalCell from './CheckoutTotalCell';
import { Badge } from 'react-bootstrap';
import CartEmptyCell from './CartEmptyCell';
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage';
import { LoadingButton } from '@mui/lab';

//const PaytmChecksum = require('./../../Payment/paytmChecksum');
//const https = require('https');


const CheckoutPage = () => {
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }
    const [{ token, huid, }, dispatch] = useStateValue();
    const [cartData, setCartData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingpayment, setLoadingPaypemt] = useState(false);



    const [coupon, setCoupon] = React.useState('');
    const couponChange = e => {
        setCoupon(e.target.value);
    };
    const [addressValue, setAddressValue] = React.useState('');
    const handleAddress = (value) => {

       // console.log('address Id pass', value)
        setAddressValue(value);
        setDeliveryAddId(value);
    };

    const [isOfferApplied, setIsOfferApplied] = useState(0);
    const [billingAddId, setBillingAddId] = React.useState('');
    const handleBillingAddress = (value) => {
        setBillingAddId(value);
        setSameBilling(false);
        setIsOfferApplied(0);
        setCoupon('');
        setCouponStatus('');
        setStatusoffer(false);
    };

    const [minicartItem, setMinicartItem] = useState(JSON.parse(localStorage.getItem("h_ct")) || []);

    const [cartEmpty, setCartEmpty] = useState(false);


    const [offerListData, setOfferList] = useState([]);

    const callCheckoutApi = () => {
        var data = new FormData();
        // data.append('inventoryItemId', productDetails?.inventoryItemId);
        // data.append('whsId', value);
        data.append('customerId', huid);
        // data.append('XAuth', token);
        data.append('cart', JSON.stringify(minicartItem));
        data.append('addressId', addressValue)
        data.append('isOfferApplied', isOfferApplied)

        // for (var pair of data.entries()) {
        //     console.log(pair[0] + ', ' + pair[1]);
        // }
        setLoading(true)
        submitCustomerCart(data).then((res) => {
            //console.log('submitCustomerCart', res.data)
            setLoading(false)
            switch (res.data.status) {
                
                case 1:
                    setCartData(res.data.cartData)
                    if (res?.data?.cartData?.cartCouponData?.couponCode?.length > 0) {
                        setCoupon(res.data.cartData.cartCouponData.couponCode)
                    }
                    setCartEmpty(false);
                    setOfferList(res.data.cartData.offerList);
                    return true;
                case 0:
                    //setCartEmpty()
                    setCartEmpty(true);
                    // dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                    // dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res?.data?.msz });
                    // dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                    break;
                case 2:
                    dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
                    break;
                default:
                    return;
            }
        })
    };


    const [deliveryAddId, setDeliveryAddId] = React.useState('');
    const [samebilling, setSameBilling] = React.useState(false);

    const [addressList, setAddressList] = React.useState([]);
    const pullAddressList = () => {
        var data = new FormData();
        data.append('customerId', huid);
        // data.append('XAuth', token);
        getCustomerAddressList(data).then((res) => {
            switch (res.data.status) {
                case 1:
                    setAddressList(res.data.customerAddress);
                    return true;
                case 0:
                    //setErrMessage(res.data.msz);
                    break;
                default:
                    return;
            }
        })
    }
    const [billingaddressList, setBillindAddressList] = React.useState([]);
    const pullBillingAddressList = () => {
        var data = new FormData();
        data.append('customerId', huid);
        // data.append('XAuth', token);
        getCustomerBillingAddress(data).then((res) => {
            switch (res.data.status) {
                case 1:
                    setBillindAddressList(res.data.customerAddress);
                    return true;
                case 0:
                    //setErrMessage(res.data.msz);
                    break;
                default:
                    return;
            }
        })
    }

    const enabledbtncoupon = coupon.length > 1;
    const [couponStatus, setCouponStatus] = useState('');
    const [statusoffer, setStatusoffer] = useState(false);


    const [removeCouponStatus, setRemoveCouponStatus] = useState(false);
    const callOfferRemove = () => {
        var data = new FormData();
        data.append('customerId', huid);
        // data.append('XAuth', token);
        offerRemove(data).then((res) => {
            switch (res.data.status) {
                case 1:
                    dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                    dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                    dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                    setRemoveCouponStatus(true);
                    setStatusoffer(false)
                    setCoupon('');
                    setCouponStatus('');
                    setIsOfferApplied(0);
                    return true;
                case 0:
                    dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                    dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                    dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                    //setErrMessage(res.data.msz);
                    break;
                default:
                    return;
            }
        })
    }

    const callCouponRedirect = () => {
        var data = new FormData();
        data.append('customerId', huid);
        // data.append('XAuth', token);
        data.append('offerCode', coupon);
        data.append('billingAddressId', billingAddId);
        // for (var pair of data.entries()) {
        //     console.log(pair[0] + ', ' + pair[1]);
        // }
        setCouponStatus('callCouponRedirect');
        offerApply(data).then((res) => {
            //console.log('offerApply', res?.data)
            switch (res.data.status) {
                case 1:
                    dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                    dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                    dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                    setCouponStatus('success');
                    setStatusoffer(true)
                    setIsOfferApplied(1);
                    return true;
                case 0:
                    dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                    dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                    dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                    setStatusoffer(false);
                    setCouponStatus('fail');
                    //setErrMessage(res.data.msz);
                    break;
                default:
                    return;
            }
        })
    }

    useEffect(() => {
        if(token){
            callCheckoutApi();
        }
        dispatch({ type: actionTypes.SET_MINICART, value: false });
    }, [minicartItem, huid, token, addressValue, isOfferApplied, removeCouponStatus]);

    const addNewAddress = () => {
        navigate("/myaccount/update-address", { state: { pageref: 'checkout' } });
    }
    const addNewBillingAddress = () => {
        navigate("/myaccount/update-billing", { state: { pageref: 'checkout' } });
    }

    const selectDeliveryAddress = (value) => {
        setDeliveryAddId(value);
    };
    const sameBillingChange = (event) => {
        setSameBilling(event.target.checked);
        if (event.target.checked) {
            setBillingAddId(null)
        }
    };

    const [paymentMode, setPaymentMode] = React.useState('paytm');
    const paymentModeChange = (value) => {
        setPaymentMode(value);
    };

    const validateForm = () => {
        if (!deliveryAddId) {
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: 'Select delivery Address.' });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            return false;
        }
        if (samebilling == false && !billingAddId) {
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: 'Select Billing Address.' });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            return false;
        }
        if (paymentMode == '') {
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: 'Select Payment Type' });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            return false;
        }
        return true;
    }

    const paytmPayment = (value) => {
    //    console.log('update orderId', CryptoJS.enc.Base64.parse(value?.orderId).toString(CryptoJS.enc.Utf8))
    //    console.log('update token', CryptoJS.enc.Base64.parse(value?.token).toString(CryptoJS.enc.Utf8))
    //    console.log('update amount', CryptoJS.enc.Base64.parse(value?.amount).toString(CryptoJS.enc.Utf8))

        const url = `${value?.url}`
        const scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.src = url.concat(CryptoJS.enc.Base64.parse(value?.mid).toString(CryptoJS.enc.Utf8));
        scriptElement.type = 'application/javascript';
        scriptElement.onload = () => {
            var config = {
                "root": "",
                "flow": "DEFAULT",
                "data": {
                    // "orderId": `${value?.orderId}` /* update order id */,
                    // "token": `${value?.token}` /* update token value */,
                    // "tokenType": `${value?.tokenType}`,
                    // "amount": `100`,
                    "orderId": CryptoJS.enc.Base64.parse(value?.orderId).toString(CryptoJS.enc.Utf8) /* update order id */,
                    "token": CryptoJS.enc.Base64.parse(value?.token).toString(CryptoJS.enc.Utf8) /* update token value */,
                    "tokenType": 'TXN_TOKEN',
                    "amount": CryptoJS.enc.Base64.parse(value?.amount).toString(CryptoJS.enc.Utf8) /* update amount */
                },
                "handler": {
                    "notifyMerchant": function (eventName, data) {
                       setLoadingPaypemt(false);
                    }
                }
            };
            if (window.Paytm && window.Paytm.CheckoutJS) {
                window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
                    // initialze configuration using init method 

                    // console.log('config paytm data final load--- foooo', config)

                    window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
                        // after successfully update configuration invoke checkoutjs
                        window.Paytm.CheckoutJS.invoke();
                    }).catch(function onError(error) {
                        // console.log("error => ",error);
                    });
                });
            }
        };
        scriptElement.onerror = error => {
            console.error('script load fail!');
        }
        document.body.appendChild(scriptElement);
        //setLoadingPaypemt(false);
    }

    // const enabledbtn = deliveryAddId > 0 && billingAddId > 0 && paymentMode.length>0;

    const makePayment = () => {
        if (validateForm()) {
            var data = new FormData();
            data.append('customerId', huid);
            // data.append('XAuth', token);
            data.append('paymentMode', paymentMode);
            data.append('deliveryAddId', deliveryAddId);
            //data.append('sameBilling', samebilling);
            data.append('billingAddId', billingAddId);
            setLoadingPaypemt(true);
            checkoutValidate(data).then((res) => {
                //console.log('makePayment---', res?.data)
                
                
               // console.log('makePayment---final price', CryptoJS.enc.Base64.parse(res?.data?.data?.testKey).toString(CryptoJS.enc.Utf8))
                
                // setLoadingPaypemt(false);
                switch (res.data.status) {
                    case 1:
                        if (res.data.data.paymentMode == 'paytm') {

                            // console.log('pass data to payment Mode', res.data.data)

                            // console.log('pass data to payment Mode orderId', CryptoJS.enc.Base64.parse(res.data.data?.orderId).toString(CryptoJS.enc.Utf8))
                            // console.log('pass data to payment Mode token', CryptoJS.enc.Base64.parse(res.data.data?.token).toString(CryptoJS.enc.Utf8))
                            // console.log('pass data to payment Mode amount', CryptoJS.enc.Base64.parse(res.data.data?.amount).toString(CryptoJS.enc.Utf8))

                            paytmPayment(res.data.data);
                            //setLoadingPaypemt(true);
                        }
                        else {
                              // console.log('paytm fail')  
                              setLoadingPaypemt(false);
                                 
                        }
                        //paytmPayment(res.data);
                        return true;
                    case 0:
                        dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                        dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                        dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                        setLoadingPaypemt(false);
                        break;
                    case 2:
                        //dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
                        setLoadingPaypemt(false);
                        break;
                    default:
                        return;
                }
            })
        } else {
            // if (captchavalue === '') {
            //     setErrorMsg('Please verify that you are not a robot.');
            // }
            // else {
            //     setErrorMsg('Please fill correct data');
            // }
        }
    }





    // sidebar for coupon
    const [state, setState] = useState({
        right: false,
    });
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };
    const myOffers = (anchor) => (
        <Box
            sx={{ width: 300 }}
            role="presentation"
        // onClick={toggleDrawer(anchor, false)}
        // onKeyDown={toggleDrawer(anchor, false)}
        >
            <div className='p-3'>
                {offerListData && offerListData?.length > 0 && offerListData?.map((item, i) => (
                    <div key={i} className='row'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='text-uppercase fw-bold border border-warning p-2 pt-1 pb-1 bglblue'>{item?.offerCode}</div>
                            <div className=''>
                                <Button className='p-0' variant='text' onClick={() => { applyCouponCode(item?.offerCode) }} color='success' >APPLY</Button>
                            </div>
                        </div>
                        <div className='mt-2'>
                            <div className='f14 fw-bold'>{item?.offerName}</div>
                            <div className='f12'>{item?.offerDesc}</div>
                        </div>
                        <hr className='mt-3' />
                    </div>
                ))}
            </div>
        </Box>
    );
    //
    const applyCouponCode = (value) => {
        setCoupon(value);
        //callCouponRedirect();
        setState({ ...state, right: false });
    }
    useEffect(() => {
        if (coupon != '') {
            callCouponRedirect();
        }
    }, [coupon]);

    useEffect(() => {
        pullAddressList();
        pullBillingAddressList();
    }, [token, huid]);

    return (
        <>
            <div className='bgred'>
                <div className='container-fluid pt-2 pb-2'>
                    <div className='d-flex align-items-center'>
                        <div className=''>
                            <IconButton onClick={goBack} size="medium" color="inherit" >
                                <ArrowBackIosIcon className='text-white' />
                            </IconButton>
                        </div>
                        <div className='text-white'><Link to="/"><img src={`/images/honda-jpg.jpg`} className="logo-sm-checkout" /></Link></div>
                    </div>
                </div>
            </div>
            {!cartEmpty ? <> <div className='innerpagebg pb-5'>
                <div className='container pt-4'>
                    <div className='row'>
                        <div className='col-12 col-lg-8'>
                            <div className='chk_login_wrap mb-3'>
                                <div className='wrap_login_s bg-white shadow-sm rounded'>
                                    <h3 className='bglblue text-black f16 text-uppercase m-0 p-3'>
                                        <span className='bgred rounded f14 d-inline-block p-2 pt-1 pb-1 me-1 text-white'>1</span>
                                        <span>Login</span>
                                        <span><CheckIcon className='f18 ms-1' color='success' /></span>
                                    </h3>
                                    <div className='login_body p-3'>
                                        <span className='f16 fw-bold'>{cartData?.customerDetails?.title} {cartData?.customerDetails?.name}</span> <span className='f16'>{cartData?.customerDetails?.phone} {cartData?.customerDetails?.email}</span>
                                    </div>
                                </div>
                            </div>
                            {deliveryAddId ? <>
                                <div className='chk_addSelected_wrap mb-3'>
                                    <div className='wrap_addSelected_s bg-white shadow-sm rounded'>
                                        <h3 className='bglblue text-black f16 text-uppercase m-0 p-3'>
                                            <span className='bgred rounded f14 d-inline-block p-2 pt-1 pb-1 me-1 text-white'>2</span>
                                            <span>Delivery Address</span>
                                            <span><CheckIcon className='f18 ms-1' color='success' /></span>
                                        </h3>
                                        <div className='addSelected_body p-3'>
                                            <div><Badge pill bg="warning" text="dark">{cartData?.customerAddress?.zipCode}</Badge><Badge pill bg="secondary" className='ms-1'>{cartData?.customerAddress?.addressType}</Badge> {cartData?.customerAddress?.addressLine1}, {cartData?.customerAddress?.addressLine2}, {cartData?.customerAddress?.city}, {cartData?.customerAddress?.state}, {cartData?.customerAddress?.country}</div>
                                            <Button color="primary" size="small" variant="outlined" onClick={() => { selectDeliveryAddress(null) }} type="submit" className='mt-2 mb-2'>
                                                Change Address
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </> :
                                <>
                                    <div className='chk_deladd_wrap mb-3'>
                                        <div className='wrap_deladd_s bg-white shadow-sm rounded'>
                                            <h3 className='bgdgray text-white f16 text-uppercase m-0 p-3'>
                                                <span className='bgred rounded f14 d-inline-block p-2 pt-1 pb-1 me-1 text-white'>2</span>
                                                <span>delivery Address</span>
                                            </h3>
                                            <div className='deladd_body'>
                                                <div className='row'>
                                                    {addressList && addressList?.length > 0 && addressList?.map((data, i) => (

                                                        <div key={i} className="col-sm-12 col-12" onClick={() => { handleAddress(data.addressId) }}>
                                                            <div className={`d-flex p-2 ${addressValue === data.addressId ? 'bgsgray' : ''}`} style={{ borderBottom: 'solid 1px #f0f0f0' }}>
                                                                <div>
                                                                    <Radio
                                                                        checked={addressValue === data.addressId}
                                                                        value={data.addressId}
                                                                        size="small"
                                                                        name="address-radio"
                                                                        className="float-start pb-0"
                                                                        inputProps={{ 'aria-label': 'A' }}
                                                                    />
                                                                </div>
                                                                <div className='flex-grow-1'>
                                                                    <div className='d-flex'>
                                                                        <div className='flex-grow-1'>
                                                                            <p className='mb-2 mt-2 f14'>{data?.addressLine1}</p>
                                                                            <p className='f13 mb-0'>{data?.addressLine2 ? <>{data?.addressLine2},</> : <></>} {data?.city}, {data?.state}, {data?.country} - {data?.zipcode}</p>
                                                                        </div>
                                                                        <div><span className='text-uppercase me-1'><Chip className='f12' size='small' label={data?.addressType} /></span></div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    ))}
                                                    {addressList && addressList.length <= 0 ? <><div className='row'>
                                                        <div className='col-lg-12'>
                                                            <div className='card text-center p-3'>
                                                                Delivery Address Not Found
                                                            </div>
                                                        </div>
                                                    </div></> : <></>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mt-2'>
                                            <div className='bg-white shadow-sm'>
                                                <Button variant="text" className='w-100'
                                                    onClick={() => { addNewAddress() }}
                                                    startIcon={<AddIcon />}>
                                                    Add a new delivery address
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            <div className='chk_deladd_wrap mb-3'>
                                <div className='wrap_deladd_s bg-white shadow-sm rounded'>
                                    <h3 className='bgdgray text-white f16 text-uppercase m-0 p-3'>
                                        <span className='bgred rounded f14 d-inline-block p-2 pt-1 pb-1 me-1 text-white'>3</span>
                                        <span>Billing To</span>
                                    </h3>
                                    <div className='deladd_body'>
                                        {/* <div className='row'>
                                                <div className='col-12'>
                                                    <FormGroup  >
                                                        <FormControlLabel className='p-2'
                                                            control={<Checkbox className='ms-2' checked={samebilling}
                                                                onChange={sameBillingChange} />} label="My Billing information is the same as my Delivey information" />
                                                    </FormGroup>
                                                </div>
                                            </div> */}
                                        <div className='deladd_body'>
                                            {!samebilling ? <>  <div className='row'>
                                                {billingaddressList && billingaddressList?.length > 0 && billingaddressList?.map((data, i) => (

                                                    <div key={i} className="col-sm-12 col-12" onClick={() => { handleBillingAddress(data.addressId) }}>
                                                        <div className={`d-flex p-2 ${billingAddId === data.addressId ? 'bgsgray' : ''}`} style={{ borderBottom: 'solid 1px #f0f0f0' }}>
                                                            <div>
                                                                <Radio
                                                                    checked={billingAddId === data.addressId}
                                                                    value={data.addressId}
                                                                    size="small"
                                                                    name="address-radio"
                                                                    className="float-start pb-0"
                                                                    inputProps={{ 'aria-label': 'A' }}
                                                                />
                                                            </div>
                                                            <div className='flex-grow-1'>
                                                                <div className='d-flex'>
                                                                    <div className='flex-grow-1'>
                                                                        <p className='f13 mb-1 mt-2'>{data?.addressLine1} {data?.addressLine2 ? <>{data?.addressLine2},</> : <></>} {data?.city}, {data?.state}, {data?.country} - {data?.zipcode}</p>
                                                                        <p className='mb-2 mt-1 f14'>
                                                                            {data?.haveGST == 'true' ? <><span className='fw-bold'>GST No.</span> {data?.gstNo}, <span className='fw-bold'>Business Name</span> {data?.businessName}</> : <></>}
                                                                        </p>
                                                                    </div>
                                                                    <div><span className='text-uppercase me-1'><Chip className='f12' size='small' label={data?.addressType} /></span></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                ))}
                                            </div></> : <></>}
                                            {billingaddressList && billingaddressList.length <= 0 ? <><div className='row'>
                                                <div className='col-lg-12'>
                                                    <div className='card text-center p-3'>
                                                        Billing Address Not Found
                                                    </div>
                                                </div>
                                            </div></> : <>
                                            </>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-2 mb-3'>
                                <div className='bg-white shadow-sm'>
                                    <Button variant="text" className='w-100'
                                        onClick={() => { addNewBillingAddress() }}
                                        startIcon={<AddIcon />}>
                                        Add a new Billing Address
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-lg-4'>
                            {loading ? <><LoadingCellFullPage /></> : <>
                                <div className='check-sidebar mb-3'>
                                    <div className='cart-review_wrap bg-white shadow-sm rounded'>
                                        <h3 className='f16 txtlgeay p-3 mb-0'>REVIEW YOUR ORDER ({cartData?.cartProductData?.length})</h3>
                                        <hr className='mt-0 mb-0' />
                                        <div className='items-wrap'>
                                            <div className='p-3 bg-white'>
                                                {cartData && cartData?.cartProductData?.length > 0 && cartData?.cartProductData?.map((data, i) => (
                                                    <CheckoutProductCell key={i} addressValue={addressValue} itemin={data} />
                                                ))}
                                            </div>
                                        </div>
                                        {offerListData && offerListData?.length > 0 ? <>
                                            <div className='bglblue p-3'>
                                            <div className='f12 mb-2'>Have a Coupon?</div>
                                            <div className='d-flex'>
                                                <div className='flex-grow-1'>
                                                    <TextField
                                                        className='w-100'
                                                        variant="standard"
                                                        name="gstno"
                                                        disabled={statusoffer}
                                                        id="gstno"
                                                        label=""
                                                        placeholder='Coupon Code'
                                                        helperText=""
                                                        value={coupon}
                                                        onChange={couponChange}
                                                    />
                                                </div>
                                                <div>
                                                    {statusoffer ? <><Button
                                                        onClick={() => { callOfferRemove() }}
                                                        variant="text" color='error' className=''>REMOVE COUPON
                                                    </Button></> : <><Button disabled={!enabledbtncoupon}
                                                        onClick={() => { callCouponRedirect() }}
                                                        variant="ountl" className=''>APPLY COUPON
                                                    </Button></>}

                                                </div>
                                            </div>
                                            {couponStatus == 'success' ? <><div className='mt-2 text-success f12'>{coupon}- coupon was successfully applied.</div></> : null}
                                            {couponStatus == 'fail' ? <><div className='mt-2 text-danger f12'>Offer Code Does not Exist.</div></> : null}
                                            <div className='mt-2 text-end'><Button onClick={toggleDrawer('right', true)} variant='text'>AVAILABLE COUPONS</Button></div>
                                        </div>
                                        </>:null}
                                       
                                        <div className='bg-white p-3'>
                                            <CheckoutTotalCell itemin={cartData?.cartSummaryData} />
                                            <div className='row d-none'>
                                                <div className='col-12'>
                                                    <div className={`box-radio-container d-flex align-items-center border rounded p-2 ${paymentMode == 'paytm' ? 'border-success' : ''}`} onClick={() => { paymentModeChange('paytm') }}>
                                                        <div className="clearfix">
                                                            <Radio
                                                                checked={paymentMode == 'paytm'}
                                                                value="paytm"
                                                                size="small"
                                                                name="radio-buttons"
                                                                className="float-start"
                                                                inputProps={{ 'aria-label': 'A' }}
                                                            />
                                                        </div>
                                                        <div className="text-center"><img src={`/images/paytm-png.png`} alt="paytm" className="" /></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='mt-4'>
                                                {!loadingpayment ? <Button color="error"
                                                    // disabled={!enabledbtn} 
                                                    variant="contained" className='w-100'
                                                    onClick={makePayment}>Continue to Payment</Button> : <LoadingButton className="w-100"
                                                        loading
                                                        loadingPosition="end"
                                                        variant="contained"
                                                    >
                                                    Continue to Payment...
                                                </LoadingButton>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>}

                        </div>
                    </div>
                </div>
            </div></> : <>
                <div className='innerpagebg pb-5'>
                    <div className='container pt-4 vh-100'>
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <CartEmptyCell />
                            </div>
                        </div>
                    </div>
                </div></>}



            <React.Fragment key='right'>
                <Drawer
                    anchor='right'
                    open={state['right']}
                    onClose={toggleDrawer('right', false)}
                >
                    <div className=''>
                        <div className='bgred'>
                            <div className='container-fluid pt-2 pb-2'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div className='text-white text-uppercase fw-bold'>Available coupons</div>
                                    <div className=''>
                                        <IconButton onClick={toggleDrawer('right', false)} size="medium" color="inherit" >
                                            <CloseIcon className='text-white' />
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {myOffers('right')}
                    </div>
                </Drawer>
            </React.Fragment>
        </>
    )
}

export default CheckoutPage